import { render, staticRenderFns } from "./EventCampusResume.vue?vue&type=template&id=1eb64fcc&scoped=true"
import script from "./EventCampusResume.vue?vue&type=script&lang=js"
export * from "./EventCampusResume.vue?vue&type=script&lang=js"
import style0 from "./EventCampusResume.vue?vue&type=style&index=0&id=1eb64fcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb64fcc",
  null
  
)

export default component.exports